import React from "react";
import { Building2, Tag, Briefcase, Home, LineChart, Handshake } from "lucide-react";
import Reveal from "@/components/Reveal";
import EnquiryForm from "@/components/public/EnquiryForm";
import { IMAGES } from "@/lib/images";

const INTERESTS = [
  { icon: Building2, t: "Businesses", d: "Established or emerging businesses with strong fundamentals." },
  { icon: Tag, t: "Brands", d: "Brands with distinctive positioning and potential." },
  { icon: Briefcase, t: "Commercial Opportunities", d: "Relevant commercial opportunities worth exploring." },
  { icon: Home, t: "Property Opportunities", d: "Property assets and development opportunities." },
  { icon: LineChart, t: "Strategic Investments", d: "Selective, considered strategic interests." },
  { icon: Handshake, t: "Joint Ventures", d: "Collaborative ventures aligned with the group." },
];

export default function Acquisitions() {
  return (
    <div data-testid="page-acquisitions" className="bg-bd-black min-h-screen">
      <section className="pt-40 pb-20 grain relative">
        <img src={IMAGES.goldSphere} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-t from-bd-black to-bd-black/70" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="overline text-bd-gold mb-6">Acquisitions & Opportunities</p>
            <h1 className="font-serif text-4xl md:text-7xl text-bd-ivory leading-[1.05] max-w-4xl">
              Discreet conversations about the right opportunities
            </h1>
            <p className="mt-8 text-base md:text-lg text-bd-ivory/60 max-w-2xl leading-relaxed">
              Black Diamond Ventures Group is interested in relevant businesses, brands, commercial and property opportunities, strategic interests and joint ventures. All conversations are handled privately.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-bd-charcoal">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {INTERESTS.map((it, i) => (
              <Reveal key={it.t} delay={(i % 3) * 0.05}>
                <div className="bg-bd-charcoal p-8 h-full">
                  <it.icon size={26} strokeWidth={1.2} className="text-bd-gold mb-5" />
                  <h3 className="font-serif text-2xl text-bd-ivory mb-2">{it.t}</h3>
                  <p className="text-sm text-bd-ivory/50 leading-relaxed">{it.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-bd-ivory">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Reveal>
            <div className="bg-white border border-black/10 p-8 md:p-12">
              <p className="overline text-bd-gold mb-4">Confidential submission</p>
              <h2 className="font-serif text-3xl md:text-4xl text-bd-black mb-3">Submit an opportunity</h2>
              <p className="text-sm text-black/50 mb-8">
                Share the outline of your opportunity. Details are reviewed privately by the group.
              </p>
              <EnquiryForm
                category="Investment/Acquisition Opportunity"
                showCompany showPhone showAttachment confidential
                submitLabel="Submit Confidential Opportunity"
              />
            </div>
            <p className="mt-6 text-xs text-black/40">
              Note: Black Diamond Ventures Group does not represent that it operates a large investment fund. Each opportunity is assessed on its individual merits.
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
